import * as actionType from '@lib/actions/AuthenticationActionType';
import { Action, Reducer } from "redux";
import { IStoreAuthenticationState } from "types";





/**
 * Reducer to handle action about login, registration, lost password
 * @param state 
 * @param action 
 */
export const authenticationReducer: Reducer<IStoreAuthenticationState> = (state: IStoreAuthenticationState, action: Action) => {
  let act;
  if (state === undefined) {
    return {
      confirmation: '',
      login: localStorage.login ? localStorage.login : '',
      password: localStorage.password ? localStorage.password : '',
      rememberMe: localStorage.rememberMe === 'false' ? false : true,
    };
  }
  switch (action.type) {
    case actionType.SIGN_OUT_ACTION:
      document.location.hash = '/';
      return { ...state, 'errorMessage': undefined, "sites": undefined };
    case actionType.RESGITER_ACTION:
      // If it was valid, a Login action would have been dispatched
      act = (action as actionType.IRegisterAction);
      return { ...state, 'errorMessage': act.errorMessage };
    case actionType.SIGN_IN_ACTION:
      act = (action as actionType.ISignInAction);
      if (act.error) {
        return { ...state, 'errorMessage': act.errorMessage };
      } else {
        // Credentials are valid, store them ?
        const payload = act.payload!;
        localStorage.rememberMe = payload.rememberMe;
        if (payload.rememberMe) {
          localStorage.login = payload.login;
          localStorage.password = payload.password;
        } else {
          localStorage.login = '';
          localStorage.password = '';
        }
        return { ...state, 'errorMessage': '', isAdmin: (payload.profile === "ADMIN" ? true : false), };
      }
    case actionType.SIGN_OUT_ACTION:
      return { ...state, "login": "test" };
    case actionType.SEND_PASSSWORD_ACTION:
      act = (action as actionType.ISendPasswordAction);
      if (act.error) {
        return { ...state, 'errorMessage': act.errorMessage };
      }
      window.location.hash = '/';
      return { ...state };
    case actionType.LOST_PASSWORD_NAVIGATE_ACTION:
      window.location.hash = 'lostPassword';
      return { ...state, 'errorMessage': '' };
    case actionType.RESGITER_NAVIGATE_ACTION:
      window.location.hash = 'register';
      return { ...state, 'errorMessage': '' };
    case actionType.CHANGE_PASSSWORD_ACTION:
      act = (action as actionType.IChangePasswordAction);
      if (!act.error) {
        window.location.hash = 'home';
      }
      return { ...state, 'errorMessage': act.errorMessage };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authenticationReducer.tsx